import detect from '../core/detect'

export default class Grid {
  get CLASSES() {
    return {
      isSelected: 'is-selected',
    };
  }

  constructor() {
    this.$grid = document.querySelector('[data-grid]');
    this.$items = [...document.querySelectorAll('[data-grid-item]')];
    if (!this.$grid) return;
    this.bool = JSON.parse(this.$grid.dataset.grid)
    this.magicGrid;
    window.addEventListener('load', () => {
      this.initGrid();
    });
  }

  initGrid() {
    this.createGrid();
  }

  createGrid() {
    if (detect.isMobile() || !this.bool) return;
    this.magicGrid = new MagicGrid({
      container: this.$grid,
      static: true,
      maxColumns: 3,
      center: true,
      gutter: 20,
    });
    this.magicGrid.listen();
  }
}
